import axiosInstance from "../axiosInterceptor";

export async function getAllUniversityByCountry() {
    const response = await axiosInstance.get(`/admin/universities/getAllUniversityByCountryStudent`);
    const data = response?.data;
    return data;
}
